export class SessionBasketTraineeQuantity {
    sessionBasketKey: number;
    userKey: number;
    traineeQuantity: number;

    constructor(sessionBasketKey: number, userKey: number, traineeQuantity: number) {
        this.sessionBasketKey = sessionBasketKey;
        this.userKey = userKey;
        this.traineeQuantity = traineeQuantity;
    }
}

export class SessionBasket {
    sessionBasketKey: number;
    userKey: number;
    sessionKey: number;

    constructor(sessionBasketKey: number, userKey: number, sessionKey: number) {
        this.sessionBasketKey = sessionBasketKey;
        this.userKey = userKey;
        this.sessionKey = sessionKey;
    }
}

export class SessionBasketOfferDuplicate {
    sessionBasketKey: number;
    userKey: number;

    constructor(sessionBasketKey: number, userKey: number) {
        this.sessionBasketKey = sessionBasketKey;
        this.userKey = userKey;
    }
}


export class SessionBasketBookable {
    sessionBasketKey: number;
    isBookable: boolean;

    constructor(sessionBasketKey: number, isBookable: boolean) {
        this.sessionBasketKey = sessionBasketKey;
        this.isBookable = isBookable;
    }
}


